export function formatHTMLString(val){
    return val
    .split("/p><p")
    .map((para) => para.replaceAll(" ", "&nbsp;"))
    .join("/p><p");
}